<template>
  <div>
    <label class="block">
      <span class="text-gray-700 aria-label">{{ label }}</span>
      <p v-if="showError" v-text="error" class="text-red-500"></p>
      <input class="hidden block" type="file" @change="upload" />
      <div
        class="mt-1 bg-gray-200 border-4 rounded-lg h-48 w-48"
        :class="{
          'border-gray-500': !showError,
          'border-red-500': showError,
          'border-dashed': !value,
        }"
      >
        <img
          v-if="value && !uploading"
          class="rounded object-cover w-full h-full"
          :src="value"
        />
        <div v-else class="h-full w-full flex items-center justify-center">
          <i
            v-if="uploading"
            class="material-icons text-6xl text-gray-500 spin"
          >
            sync
          </i>
          <i v-else class="material-icons text-6xl text-gray-500">
            add_circle_outline
          </i>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
  },
  props: ["label", "value", "error"],
  data() {
    return {
      uploadUrl: "https://api.cloudinary.com/v1_1/ika/upload",
      uploadPreset: "azwuc5j0",
      uploading: false,
      showError: false,
    };
  },
  created() {
    this.showError = !!this.error;
  },
  watch: {
    error(newValue) {
      this.showError = !!newValue;
    },
  },
  methods: {
    upload(e) {
      if (e.target.files.length !== 1) return false;

      this.uploading = true;

      let file = e.target.files[0];

      let fd = new FormData();
      fd.append("file", file);
      fd.append("upload_preset", this.uploadPreset);

      this.$http
        .post(this.uploadUrl, fd, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          this.$emit("input", response.data.url);
          this.showError = false;
        })
        .catch(err => console.log(err))
        .finally(() => (this.uploading = false));
    },
  },
};
</script>
